import React, { useEffect, useState } from 'react';
import SongList from './SongList'
import PlaylistLink from './PlaylistLink'


const ListSong = (props) => {

  let valence = props.emotions.happiness+props.emotions.surprise-props.emotions.anger-props.emotions.fear
    -props.emotions.contempt-props.emotions.disgust;
 
  if(props.emotions.neutral > Math.abs(valence)){
    valence = 0.5
  }

  const [tracks, setTracks] = useState([]);
  const [value, setValue] = useState('');
  const [link, setLink] = useState('');
  const [tracksUris, setTracksUris] = useState([]);
  
  useEffect(() => {

    async function getData(){
      const data = await getRecommendations();
      console.log(data);
      setTracks(data);
    } 
    getData()  
    
  }, [])

  async function regenerateTracks(){
    const data = await getRecommendations();
      console.log(data);
      setTracks(data);
  }

  async function getTop(type, limit){
    const time_range = "medium_term";
    const result = await fetch(`https://api.spotify.com/v1/me/top/${type}?time_range=${time_range}&limit=${limit}`, {
        method: 'GET',
        headers: { 'Authorization' : 'Bearer ' + props.token}
    });
    const data = await result.json();
    console.log(data.items); 
    return data.items;
  } 

  //GET RECOMMENDATIONS FUNCTION
  async function getRecommendations(){

    const numTracks = 2;
    const numArtists = 3;
  
    const topTracks = await getTop('tracks', numTracks)
    let seedTracks = topTracks.map(track => track.id) 
    
    const topArtists = await getTop('artists', numArtists)
    let seedArtists = topArtists.map(artist => artist.id)

    let minValence = 0;
    let maxValence = 1;

    if (valence < .33){
        maxValence = .33;
    }
    else if (valence > .66){
        minValence = .66;
    }
    else{
        minValence = .4;
        maxValence = .7;
    }

    console.log("min: " + minValence);
    console.log("max: " + maxValence);

    let payload = new URLSearchParams({
      'min_popularity': '70',
      'limit': 10,
      'seed_tracks': `${seedTracks}`,
      'seed_artists': `${seedArtists}`,
      'min_valence': `${minValence}`,
      'max_valence': `${maxValence}`,
      'min_energy': `${minValence}`,
      'max_energy': `${maxValence}`
    })

    const result = await fetch(`https://api.spotify.com/v1/recommendations?` + payload.toString(), {
        method: 'GET',
        headers: { 'Authorization' : 'Bearer ' + props.token},
    });

    //console.log('before call');
    const data = await result.json();
    let recommendedTracksUri = [];
    for (let i = 0; i < data.tracks.length; i++){
      recommendedTracksUri.push(data.tracks[i].uri);
    }

    setTracksUris(recommendedTracksUri);

    return data.tracks;
  }

  const createPlaylist = async() => {
 
    let id = props.id
    let params = {
      "name": "Better Song Recommendations",
      "description": "generated by better-song-rec.herokuapp.com",
      "public": false
    }
    const resp = await fetch(`https://api.spotify.com/v1/users/${id}/playlists`, {
      method: 'POST',
      headers: { 'Authorization' : 'Bearer ' + props.token, 'Content-Type': 'application/json'},
      body: JSON.stringify(params)
    });
    const data = await resp.json();
    setLink(data.external_urls.spotify)  
 
    addTracks(data.id);

    setValue("Go to playlist -->")
  }

  const addTracks = (id) => {

    let params = {
      "uris": tracksUris
    } 
    console.log(params)
  fetch(`https://api.spotify.com/v1/playlists/${id}/tracks`, {
    method: 'POST',
    headers: { 'Authorization' : 'Bearer ' + props.token, 'Content-Type': 'application/json'},
    body: JSON.stringify(params)
    }).then(console.log('tracksadded!'))
  }

  return (
    <div className='song-page'>
      <SongList recommendedTracks={tracks}/>
      <div className="song-buttons">
        <button className="green-btn" onClick={() => regenerateTracks()}>Regenerate Songs</button>
        <button className="green-btn" onClick={() => createPlaylist()}>Create playlist from these songs</button>
        <PlaylistLink link={link} value={value}/>
      </div>
    </div>
  )
}

export default ListSong;
